import { CallingService } from '../calling.service';
import { resolveCubeBreakType } from './cube-break-types';

/**
 * Legacy Cube API dialer controller (non-webphone). Delegates to CallingService HTTP APIs.
 */
export class CubeController {
  constructor(private callingService: CallingService) {}

  pauseCall(params) {
    const breakType = resolveCubeBreakType(params?.breakType);
    return this.callingService.pauseCubeCall({ ...params, breakType });
  }

  resumeCall() {
    return this.callingService.resumeCubeCall();
  }

  stopCall() {
    return this.callingService.stopCubeCall();
  }

  holdCall() {
    return this.callingService.holdCubeCall();
  }

  unholdCall() {
    return this.callingService.unholdCubeCall();
  }

  dropCall() {
    return this.callingService.dropCubeCall();
  }

  toggleStartMode() {
    return this.callingService.startManualMode();
  }

  toggleStopMode() {
    return this.callingService.stopManualMode();
  }

  manualOutboundCall(postObj) {
    return this.callingService.manualOutboundCubeCall(postObj);
  }

  mergeCall(postObj) {
    return this.callingService.mergeCall(postObj);
  }

  unMergeCall() {
    return this.callingService.unMergeCall();
  }

  transferCall(postObj) {
    return this.callingService.transferCall(postObj);
  }

  conferenceCall(postObj) {
    return this.callingService.conferenceCall(postObj);
  }

  completeConference(postObj) {
    return this.callingService.completeCubeConference(postObj);
  }

  autoDisposeCall(postObj) {
    return this.callingService.autoDisposeCall(postObj);
  }

  disposeCallRaphsody(postObj) {
    return this.callingService.disposeCubeCallRaphsody(postObj);
  }

  getAgentStatus() {
    return this.callingService.getCubeAgentStatus();
  }

  fetchCallLogs(postObj) {
    return this.callingService.fetchCubeCallLogs(postObj);
  }
}
